module.exports = "/images/customer_service_policy.svg?6fa3740d14f619eeed24384c3f001884";